import { ReactNode } from "react";
import { cx } from "shared/utils/classnames";

export const CreditScoreTimeLine = ({
  wrapperClassName,
  children,
  noBorder
}: {
  wrapperClassName?: string;
  children: ReactNode;
  noBorder?: boolean;
}) => {
  return (
    <div
      className={cx(
        noBorder ? "" : "border-l-4",
        wrapperClassName || "ml-2 border-primary-500 pl-2 pt-1"
      )}
    >
      <ul className="w-full">{children}</ul>
    </div>
  );
};
